// types
import { Act } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// headers
import { getHeaders } from './TableBasicActs.headers';

// props
export interface TableBasicActsProps extends Omit<TableProps, 'headers'> {
	data: Act[];
}

export const TableBasicActs = ({ data = [], ...props }: TableBasicActsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getHeaders({ t });

	return <Table {...props} headers={headers} data={data} />;
};
